<template>
    <div class="sedative-input-group">
        <div class="header-text">Sedatives 
            <v-btn id="add-sedatives" icon　@click="handleSedativeAction('add', $event)">
                <v-icon>add</v-icon>
            </v-btn>
        </div>
        <template v-for="(item, index) in sedativesList">
            <sedative-input
                :key="index"
                :data="item"
                :medList="sedativesSelectItems"
                hideDetails
                align="end"
                @removeSedative="handleSedativeAction('delete', $event)"
                @change="handleSedativeChange($event)"
            ></sedative-input>
        </template>
        <br/>
        <v-layout class="others">
            <v-text-field flex xs4
                label="others"
                v-model="sedativeOtherText"
                @change="selectOther($event)"
                hide-details
            ></v-text-field>
        </v-layout>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import forms from '@/utils/forms'
import SedativeInput from '@/components/SedativeInput.vue'

export default {
    name: 'SedativeInputGroup',

    components: {
        SedativeInput
    },

    props: {
        examinationID: {
            type: Number
        },
        sedativeOther:{
            type: String
        },
        // all sedative info
        sedatives: {
            type: Array,
        },
        // current exam's sedative info
        sedativesList: {
            type: Array,
            required: true,
        },
    },

    data () {
        return {
            checkOthers: false,
            sedativeOtherText: this.sedativeOther
        }
    },

    computed: {
        ...mapGetters('examinations', [
            'getSedativeList'
        ]),
        sedativesSelectOptions () {
            return this.sedatives
        },

        sedativesSelectItems () {
            return forms.mapSedativesSelectItems(this.getSedativeList)
        }
    },
    methods: {
         ...mapActions('examinations', [
            'updateExaminationSedativeColumn',
            'addExaminationSedative',
            'deleteExaminationSedative'
        ]),

        
        handleSedativeChange ({ column, event, id }) {
            this.updateExaminationSedativeColumn({
                column,
                value: Number(event),
                id
            })
        },

        handleSedativeAction (action, event) {
            const examinationSedativeID = event ? event.id : null
                this[`${action}ExaminationSedative`]({
                examinationID: this.examinationID,
                examinationSedativeID
            })
        },

        selectOther(value) {
            this.$emit('change', { field: 'sedativeOther', event: value })
        }
    }
}
</script>